"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var enums_1 = require("../enums");
var appender_console_native_1 = require("../appenders/appender.console-native");
var appender_console_1 = require("../appenders/appender.console");
var appender_remote_1 = require("../appenders/appender.remote");
var appender_empty_1 = require("../appenders/appender.empty");
function intersect(array1, array2) {
    return array1.filter(function (value) { return array2.indexOf(value) !== -1; });
}
var nonCustomTypes = [enums_1.AppenderType.Console, enums_1.AppenderType.ConsoleNative, enums_1.AppenderType.Remote];
var typeMapper = (_a = {},
    _a[enums_1.AppenderType.Console] = appender_console_1.ConsoleAppender,
    _a[enums_1.AppenderType.ConsoleNative] = appender_console_native_1.ConsoleNativeAppender,
    _a[enums_1.AppenderType.Remote] = appender_remote_1.RemoteAppender,
    _a[enums_1.AppenderType.Empty] = appender_empty_1.EmptyAppender,
    _a[enums_1.AppenderType.Custom] = appender_empty_1.EmptyAppender,
    _a);
function populateAppenders(oldConfig, newConfig, setConfigOptions) {
    if (setConfigOptions.mode === enums_1.ConfigMode.Debug) {
        console.log("oldConfig: " + JSON.stringify(oldConfig));
        console.log("newConfig: " + JSON.stringify(newConfig));
        console.log("setConfigOptions: " + JSON.stringify(setConfigOptions));
    }
    // new appenders are
    // 1. all custom appenders specified explictly.
    var newAppenders_1 = newConfig.appenders ? newConfig.appenders : [];
    // 1.1 all new appenders which are set explicitly if `setConfigOptions.keepExplicitlySetAppenders` is described as true (e.g. useful for the unit tests)
    // If this options is on, if you want to overwrite old appenders, set so in the config!
    // e.g. (timber.setConfig({appenderTypes: [AppenderType.Console], appenders: []})
    if (!setConfigOptions.keepExplicitlySetAppenders) {
        newAppenders_1 = newAppenders_1.filter(function (x) { return x.type == enums_1.AppenderType.Custom; });
    }
    // 2. appenders set via _new_ appender types
    var previousAppenderTypes = oldConfig && oldConfig.appenderTypes ? oldConfig.appenderTypes : [];
    var newAppendersFromTypes_2 = newConfig.appenderTypes.map(function (x) { return new typeMapper[x](); })
        .filter(function (x) { return x.type !== enums_1.AppenderType.Empty; })
        .filter(function (x) { return previousAppenderTypes.indexOf(x.type) === -1; });
    // 2.1. if appender from appenders field is set explictly, we don't need to populate it from appenderTypes.
    var newAppenderTypesFromAppenders = intersect(newAppenders_1.map(function (x) { return x.type; }), nonCustomTypes);
    newAppendersFromTypes_2 = newAppendersFromTypes_2.filter(function (x) { return newAppenderTypesFromAppenders.indexOf(x.type) === -1; });
    // 3. old appenders with same appender types in old and new config.
    var oldAppenders = oldConfig && oldConfig.appenders ? oldConfig.appenders : [];
    var preservedAppenders_3 = oldAppenders.filter(function (x) { return newConfig.appenderTypes.indexOf(x.type) !== -1; });
    // 3.1. If we have non-custom new appenders (1.) set explicitly, old appenders are not included;
    var oldAppenderTypesFromAppenders = intersect(oldAppenders.map(function (x) { return x.type; }), nonCustomTypes);
    var oldAppenderTypesFromNewAppenders = intersect(newAppenders_1.map(function (x) { return x.type; }), oldAppenderTypesFromAppenders);
    preservedAppenders_3 = preservedAppenders_3.filter(function (x) { return oldAppenderTypesFromNewAppenders.indexOf(x.type) === -1; });
    newConfig.appenders = newAppenders_1
        .concat(newAppendersFromTypes_2)
        .concat(preservedAppenders_3);
    if (setConfigOptions.mode === enums_1.ConfigMode.Debug) {
        console.log("resultedConfig: " + JSON.stringify(newConfig));
    }
    return newConfig;
}
exports.populateAppenders = populateAppenders;
//# sourceMappingURL=appenders.population.js.map